<template>
  <div>

    <template>
      <mdb-container>
        <mdb-modal
          :show="confirmar"
          @close="confirmar = false"
          size="sm"
          class="text-center"
          style="top:40px;"
          danger
        >
          <mdb-modal-header center :close="false">
            <p class="heading">Confirmar que quieres eliminar la campaña {{campaignSelected.name}}</p>
          </mdb-modal-header>
          <mdb-modal-body>
            <mdb-icon icon="times" size="4x" class="animated rotateIn" />
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="eliminar()">Si</mdb-btn>
            <mdb-btn color="danger" @click="confirmar = false">No</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </mdb-container>
    </template>

    <template>
        <mdb-modal class="modal-contenedor" :show="modal" @close="modal = false" fullHeight info removeBackdrop>
          <mdb-modal-header center :close="false">
            <p class="heading lead">{{modalName}}</p>
          </mdb-modal-header>
          <mdb-modal-body class="modal-body">
             <modal-create-campaign
            :onClick="closeModalCreate"
            v-if="modalName=='Crear'"
            ></modal-create-campaign>
            <modal-edit-campaign
            :onClick="closeModalCreate"
            :campaign="campaignSelected"
            v-if="modalName=='Editar'"
            ></modal-edit-campaign>
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="modal = false">Cancelar</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </template>

    
        


    <b-card>
      <modals-container v-model="items" />


      <b-btn variant="primary" class="p-2 mb-4" @click="openModal('Crear')">
        <i class="far fa-edit mr-1"></i>
        Nueva campaña
      </b-btn>
      <div slot="header" v-html="caption"></div>
      <b-table
        :dark="dark"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        responsive="sm"
        :items="items"
        :fields="captions"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="acciones" slot-scope="data">
          <b-row>
            <mdb-dropdown>
              <mdb-dropdown-toggle slot="toggle" outline="primary">Acciones</mdb-dropdown-toggle>
              <mdb-dropdown-menu>
                <mdb-dropdown-item class="mb-2" style="background: #4285f4; color:#fff;" @click="selectCampaignEdit(data.item,items)">
                  <i class="far fa-edit mr-1 pl-1" style="color:#fff" ></i>Editar
                </mdb-dropdown-item>
                <mdb-dropdown-item  class="mb-2" style="background: #ff3547; color:#fff;" @click="selectCampaignDelete(data.item)" >
                    <i class="far fa-trash-alt mr-1 pl-1" style="color:#fff"></i>Eliminar
                </mdb-dropdown-item>
                <div class="dropdown-divider"></div>
                <mdb-dropdown-item class="mb-2 " style="background: #00c851; color:#fff;"  >
                  Programar publicación
                </mdb-dropdown-item>
                <mdb-dropdown-item class="mb-2 " style="background: #00c851; color:#fff;"  >
                  Ir al business Manager
                </mdb-dropdown-item>
              </mdb-dropdown-menu>
            </mdb-dropdown>
          </b-row>
        </template>

        <template slot="objective_id" slot-scope="data">
          <b-row>
              <b-badge variant="primary" class="p-2">{{data.item.objective_id.name}}
              </b-badge>
            
          </b-row>
        </template>

        <!--<template slot="status" slot-scope="data">
          <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
        </template>-->
      </b-table>
      <nav>
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        />
      </nav>
    </b-card>
  </div>
</template>

<script>
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle
} from "mdbvue";
import ModalCreateCampaign from '../notifications/ModalCreateCampaign'
import ModalEditCampaign from '../notifications/ModalEditCampaign'
export default {
  name: "table-campaign",
  inheritAttrs: false,
  components: {
    ModalCreateCampaign,
    mdbContainer,
    SemipolarSpinner,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    ModalEditCampaign,
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle
  },
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      modalCreate: false,
      modal: false,
      isLoadingLine: false,
      id: "",
      nameLine: "",
      descriptionLine: "",
      modalName: "",
      confirmar: false,
      campaignSelected: {}
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    },
    closeModalCreate() {
      this.modal = false;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    selectCampaignEdit(item, items) {
      this.campaignSelected = item;
      this.modalName = "Editar";
      this.modal = true;
    },
    selectCampaignDelete(item) {
      this.campaignSelected = item;
      this.modalName = "Eliminar";
      this.confirmar = true;
    },
    openModal(etapa) {
      this.modalName = etapa;
      this.modal = true;
    },
    eliminar() {
      setTimeout(() => {
        store.dispatch("deleteCampaignUtility", this.campaignSelected.id);
      }, 400);
      store.dispatch("deleteCampaign", this.campaignSelected.id);
      this.confirmar = false;
    }
  }
};
</script>

<style scoped>
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}
</style>
